import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { Space, Typography } from '@sravni/react-design-system';

import { CurrencyFormatter } from 'shared/lib';

import { calculatePayment } from '../lib/calculate';
import { formatDateWithOffset } from '../lib/formatDateWithOffset';

import { ShortRefundInfo } from './ShortRefundInfo';

const { Text, Heading } = Typography;

export const RefundInfo = () => {
  const { watch } = useFormContext();

  const amount = watch('amount');
  const period = watch('period');

  const isDaysPeriod = amount < 100_000;

  const validPeriod = isDaysPeriod ? period : period * 30;

  const isShowShortDebt = Number(validPeriod) < 34;

  const repaymentDate = formatDateWithOffset(Number(validPeriod) - 1);

  const paymentText = Number(amount) > 100_000 ? 'раз в месяц' : 'раз в 2 недели';
  const calculations = calculatePayment(Number(amount), Number(validPeriod));

  if (isShowShortDebt) {
    return <ShortRefundInfo />;
  }

  return (
    <Space>
      <Space
        direction="column"
        size={4}
      >
        <Text>К возврату {repaymentDate}</Text>
        <Space
          direction="row"
          size={8}
          align="center"
        >
          <Heading level={4}>{CurrencyFormatter.formatCurrency(calculations)}</Heading>
          <Text className="h-color-D60">{paymentText}</Text>
        </Space>
      </Space>
    </Space>
  );
};
